module.exports = __webpack_public_path__ + "resources/img/img_alyac1.ab4f15724c13773db4c89fd282858ff0.png";